import React from 'react';
import { PageContainer } from '../layout/PageContainer';

export function PageLoading({ message }) {
  return (
    <PageContainer>
      <div className="flex min-h-[40vh] flex-col items-center justify-center gap-4">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-brand-600 border-t-transparent" />
        {message ? <p className="text-sm text-zinc-600">{message}</p> : null}
      </div>
    </PageContainer>
  );
}
